module.exports = __webpack_public_path__ + "img/qilu1.82f10124.png";